export const propMisc = {
  // valoracionHuespedes.vue
  reviews: {
    title: "Opinie gości",
    subtitle: "Poproś o opinię przez WhatsApp w dniu check-outu. Ustaw link, pod którym goście mają zostawiać swoje opinie.",
    bulkNotice: "Ta zmiana obejmie wszystkie zakwaterowania powiązane z tą ofertą ({count}).",
    enableTitle: "Włącz opinie gości",
    enableSub: "W dniu check-outu automatycznie wysyłana jest wiadomość WhatsApp z prośbą o opinię.",
    modeSingleTitle: "Jeden link",
    modeSingleSub: "Ten sam dla każdej rezerwacji",
    modePerOtaTitle: "Jeden link na OTA",
    modePerOtaSub: "W zależności od kanału rezerwacji",
    linkLabel: "Link do opinii",
    singleUrlPlaceholder: "https://g.page/r/… lub link do Twojej strony z opiniami",
    otaNamePlaceholder: "Nazwa serwisu",
    otaUrlPlaceholder: "https://… link do opinii",
    removeTitle: "Usuń",
    addOta: "Dodaj kolejny serwis",
    saving: "Zapisywanie…",
    saveConfig: "Zapisz ustawienia",
    note: "Goście otrzymają link odpowiadający sposobowi, w jaki dokonali rezerwacji.",
    toastLoadError: "Nie udało się wczytać danych oferty.",
    urlErrorProtocol: "URL musi zaczynać się od http:// lub https://",
    urlErrorInvalid: "Wpisz prawidłowy URL (np. https://g.page/...)",
    toastStateUpdated: "Status został zaktualizowany",
    toastStateError: "Coś poszło nie tak podczas aktualizacji statusu",
    toastUrlRequired: "Wpisz URL przed zapisaniem",
    toastSaved: "Ustawienia zostały zapisane",
    toastSaveError: "Coś poszło nie tak podczas zapisywania",
  },

  // AccessSummary.vue
  access: {
    tag: "Zamki i dostęp",
    dynamicTitle: "Podłączony zamek inteligentny",
    dynamicDetail: "Każda rezerwacja automatycznie generuje nowy kod i wysyła go gościowi.",
    chipCheckin: "Wysyłany po zakończeniu check-inu",
    chipTime: "Wysyłany o {time} w dniu przyjazdu",
    chipManual: "Wysyłasz go ręcznie",
    staticTitle: "Zamek ze stałym kodem",
    staticDetail: "Gość otrzymuje kod do skrytki lub zamka, aby wejść.",
    noneTitle: "Przekazuję klucze osobiście",
    noneDetail: "Przekazanie kluczy ustalasz z gościem w dniu przyjazdu.",
  },

  // ButtonUpdatePropertyPrice.vue
  updatePrice: {
    update: "Zaktualizuj cenę",
    saving: "Zapisywanie…",
  },

  // MossosConnections.vue
  mossos: {
    intro: "Połącz każdą jednostkę tej oferty z jej placówką w systemie Mossos (każda jednostka może mieć własny identyfikator policyjny). Check-iny są wysyłane automatycznie do właściwej placówki na podstawie jednostki z rezerwacji.",
    wholeListing: "Cała oferta",
    wholeListingDefault: "Cała oferta (domyślnie)",
    unitNumber: "Jednostka #{id}",
    badgeSendError: "Błąd wysyłki",
    badgeConnected: "Połączono",
    badgeNoCredentials: "Brak danych logowania",
    emptyList: "Nie ma jeszcze połączeń. Dodaj po jednym dla każdej jednostki oferty.",
    addConnection: "Dodaj połączenie",
    editConnection: "Edytuj połączenie",
    newConnection: "Nowe połączenie",
    unit: "Jednostka",
    unitPlaceholder: "Wybierz jednostkę",
    unitHint: "Do której jednostki oferty należy ta placówka.",
    step1Title: "Dostęp do strony Mossos",
    usuariLabel: "Usuari (strona Mossos)",
    savedHint: "zapisane",
    usuariPlaceholderKeep: "Pozostaw puste, aby nie zmieniać",
    usuariPlaceholderNew: "Nazwa użytkownika do logowania na stronie",
    passLabel: "Paraula de pas",
    passBlankHint: "puste, aby nie zmieniać",
    passPlaceholder: "Hasło do strony Mossos",
    validateHint: "Zweryfikuj, aby pobrać placówki przypisane do Twojego konta.",
    searching: "Wyszukiwanie…",
    validateSearch: "Zweryfikuj i znajdź placówki",
    step2Title: "Placówka dla tej jednostki",
    establishmentPlaceholder: "Wybierz placówkę",
    revalidateHint: "Zweryfikuj ponownie, aby to zmienić.",
    validateAbove: "Zweryfikuj powyżej, aby wybrać placówkę dla tej jednostki.",
    checkinTime: "Godzina rozliczenia (przyjazd)",
    checkoutTime: "Godzina wyjazdu",
    cancel: "Anuluj",
    savingBtn: "Zapisywanie...",
    updateConnection: "Zaktualizuj połączenie",
    saveConnection: "Zapisz połączenie",
    warnCredentials: "Wpisz usuari i paraula de pas do strony Mossos.",
    foundEstablishments: "Znaleziono placówki: {count}. Wybierz tę dla tej jednostki.",
    noEstablishments: "Nie znaleziono placówek na tym koncie.",
    connectError: "Nie udało się połączyć z Mossos. Sprawdź swoje usuari i hasło.",
    validateFirst: "Zweryfikuj i wybierz placówkę dla tego połączenia.",
    savedOk: "Połączenie z Mossos zostało zapisane.",
    saveError: "Nie udało się zapisać połączenia.",
    saveErrorGeneric: "Błąd podczas zapisywania połączenia z Mossos.",
    confirmDelete: `Usunąć połączenie dla "{unit}" ({id})?`,
    deletedOk: "Połączenie zostało usunięte.",
    deleteError: "Nie udało się usunąć połączenia.",
  },

  // SesAccounts.vue + modalPoliceData.vue — varias cuentas de SES por anuncio
  ses: {
    intro: "Każda jednostka zgłasza swoich gości przez konto SES Hospedajes. Możesz używać jednego konta dla całej oferty albo przypisać inne wybranym jednostkom, na przykład gdy każdy apartament ma własny kod placówki.",
    defaultName: "Placówka {code}",
    badgeConnected: "Połączono",
    badgeError: "Błąd weryfikacji",
    badgePending: "Niezweryfikowane",
    user: "Użytkownik",
    lessor: "Wynajmujący",
    establishment: "Placówka",
    appliesWhole: "Cała oferta:",
    appliesUnits: "Jednostki:",
    noUnits: "Nie używa go żadna jednostka",
    allUnits: "Wszystkie jednostki ({count})",
    moreUnits: "+{count} więcej",
    andMore: "i {count} więcej",
    emptyList: "Nie połączono jeszcze żadnego konta SES Hospedajes.",
    withoutAccountTitle: "Bez konta:",
    withoutAccountText: "Ich check-iny nie są zgłaszane do SES Hospedajes.",
    addAccount: "Dodaj konto",
    edit: "Edytuj",
    remove: "Usuń",
    newTitle: "Nowe konto SES Hospedajes",
    editTitle: "Edytuj konto SES Hospedajes",
    aliasLabel: "Nazwa konta (opcjonalnie)",
    aliasPlaceholder: "Np. Penthouse'y, Apartament 2B",
    aliasHint: "Służy tylko do rozpoznania go tutaj. Jeśli zostanie puste, konto jest pokazywane po kodzie placówki.",
    loginTitle: "Dostęp do Ministerstwa",
    loginSame: "Ten sam użytkownik i hasło",
    loginSameHint: "Wpisujesz tylko kody tego konta.",
    loginOwn: "Inny użytkownik i hasło",
    loginFrom: "Użyj dostępu z konta",
    passwordKeep: "Zostaw puste, aby nie zmieniać",
    passwordNeeded: "Wpisz hasło nowego użytkownika.",
    passwordShared: "Tego użytkownika używają też inne konta oferty ({count}): zmiana hasła zaktualizuje je we wszystkich.",
    scopeTitle: "Których jednostek dotyczy?",
    scopeWhole: "Cała oferta",
    scopeWholeHint: "Używają go jednostki, które nie mają innego konta.",
    scopeWholeTaken: "Jest nim już „{name}”.",
    scopeUnits: "Tylko wybrane jednostki",
    scopeUnitsHint: "Ty wybierasz które.",
    unitNow: "teraz: {name}",
    unitNowWhole: "teraz: konto całej oferty",
    unitNowNone: "bez konta",
    leftWithout: "po zapisaniu bez konta. Ich check-iny przestaną być zgłaszane do SES Hospedajes.",
    leftToWhole: "po zapisaniu zgłoszenia będą wysyłane przez konto całej oferty „{name}”.",
    errUnits: "Wybierz co najmniej jedną jednostkę.",
    errDefaultExists: "Ta oferta ma już konto dla wszystkich swoich jednostek.",
    errDuplicate: "Masz już to konto w tej ofercie. Edytuj je i dodaj jednostki.",
    errCopyFrom: "Nie udało się użyć dostępu z tego konta. Wpisz go ręcznie.",
    savedValidated: "Konto zapisane i zweryfikowane przez Ministerstwo.",
    savedNotValidated: "Zapisano, ale Ministerstwo odrzuca dane. Sprawdź je.",
    savedUnchecked: "Konto zapisane. TRA nie pozwala sprawdzić tokenu z wyprzedzeniem: okaże się przy pierwszej wysyłce.",
    passwordSynced: "Hasło zaktualizowano też w {count} kontach z tym samym użytkownikiem.",
    removeTitle: "Usunąć to konto?",
    removeNoUnits: "Konto „{name}” zostanie usunięte. Nie używa go żadna jednostka.",
    removeToFallback: "„{name}” zostanie usunięte. Jednostki, które go używają ({units}), będą zgłaszać przez konto całej oferty „{fallback}”.",
    removeToNothing: "„{name}” zostanie usunięte. Jednostki, które go używają ({units}), zostaną bez konta, a ich check-iny przestaną być zgłaszane do SES Hospedajes.",
    removeConfirm: "Tak, usuń",
    removed: "Konto usunięte.",
    removeError: "Nie udało się usunąć konta.",
  },

  // Colombia — varias cuentas de SIRE y de TRA por anuncio (ColombiaAccounts.vue,
  // ColombiaAccountModal.vue y el aviso de cuentas de otro país en Autoridades.vue).
  co: {
    loading: "Wczytywanie kont…",
    saving: "Zapisywanie…",
    close: "Zamknij",
    show: "Pokaż",
    hide: "Ukryj",

    badgeConnected: "Połączono",
    badgeError: "Błąd weryfikacji",
    badgePending: "Niezweryfikowane",
    badgeOnSend: "Sprawdzane przy wysyłce",

    edit: "Edytuj",
    remove: "Usuń",
    addAccount: "Dodaj konto",

    appliesWhole: "Cała oferta:",
    appliesUnits: "Jednostki:",
    noUnits: "Nie używa go żadna jednostka",
    allUnits: "Wszystkie jednostki ({count})",
    moreUnits: "+{count} więcej",
    andMore: "i {count} więcej",
    withoutAccountTitle: "Bez konta:",

    scopeTitle: "Których jednostek dotyczy?",
    scopeWhole: "Cała oferta",
    scopeWholeHint: "Używają go jednostki, które nie mają innego konta.",
    scopeWholeTaken: "Jest nim już „{name}”.",
    scopeUnits: "Tylko wybrane jednostki",
    scopeUnitsHint: "Ty wybierasz które.",
    unitNow: "teraz: {name}",
    unitNowWhole: "teraz: konto całej oferty",
    unitNowNone: "bez konta",
    leftToWhole: "po zapisaniu zgłoszenia będą wysyłane przez konto całej oferty „{name}”.",

    aliasLabel: "Nazwa konta (opcjonalnie)",
    aliasPlaceholder: "Np. Wieża północna, Apartament 301",
    loginFrom: "Użyj dostępu z konta",
    secretKeep: "Zostaw puste, aby nie zmieniać",

    errUnits: "Wybierz co najmniej jedną jednostkę.",
    errDefaultExists: "Ta oferta ma już konto dla wszystkich swoich jednostek.",
    errDuplicate: "Masz już to konto w tej ofercie. Edytuj je i dodaj jednostki.",
    errCopyFrom: "Nie udało się użyć dostępu z tego konta. Wpisz go ręcznie.",
    errNoListing: "Nie znaleźliśmy oferty. Otwórz ekran ponownie.",
    saveError: "Nie udało się zapisać konta.",

    removeTitle: "Usunąć to konto?",
    removeConfirm: "Tak, usuń",
    removeNoUnits: "Konto „{name}” zostanie usunięte. Nie używa go żadna jednostka.",
    removeToFallback: "„{name}” zostanie usunięte. Jednostki, które go używają ({units}), będą zgłaszać przez konto całej oferty „{fallback}”.",
    removeToNothing: "„{name}” zostanie usunięte. Jednostki, które go używają ({units}), zostaną bez konta i przestaną przekazywać dane do {authority}.",
    removed: "Konto usunięte.",
    removeError: "Nie udało się usunąć konta.",

    sire: {
      name: "SIRE",
      subtitle: "Sistema de Información para el Registro de Extranjeros — Migración Colombia",
      intro: "Każda jednostka zgłasza swoich gości do SIRE przez konto. Możesz używać jednego konta dla całej oferty albo przypisać inne wybranym jednostkom, na przykład gdy każdy apartament jest zarejestrowany z własnym kodem placówki.",
      introSingle: "Połącz konto, przez które ta oferta zgłasza swoich gości do SIRE.",
      emptyList: "Nie połączono jeszcze żadnego konta SIRE.",
      withoutAccountText: "Ich check-iny nie są zgłaszane do SIRE.",
      newTitle: "Nowe konto SIRE",
      editTitle: "Edytuj konto SIRE",
      modalSub: "To dane, którymi logujesz się do SIRE",
      defaultName: "Placówka {code}",
      defaultNameDoc: "Dokument {document}",
      docTypeLabel: "Rodzaj dokumentu",
      docType_CO_ID: "Dowód tożsamości obywatela (cédula de ciudadanía)",
      docType_CO_FID: "Dowód tożsamości cudzoziemca (cédula de extranjería)",
      documentLabel: "Numer dokumentu",
      documentPlaceholder: "Np. 1012345678",
      documentHint: "To użytkownik, którym logujesz się do SIRE.",
      passwordLabel: "Hasło",
      passwordPlaceholder: "Hasło do SIRE",
      passwordShared: "Ten dokument używają też inne konta oferty ({count}): zmiana hasła zaktualizuje je we wszystkich.",
      estLabel: "Kod placówki (opcjonalnie)",
      estPlaceholder: "Np. 67890",
      estHint: "Potrzebny tylko wtedy, gdy tym samym dostępem zgłaszasz kilka obiektów. Jeśli zostanie puste, użyjemy tego, który masz zarejestrowany.",
      loginTitle: "Dostęp do SIRE",
      loginSame: "Ten sam dokument i hasło",
      loginSameHint: "Wpisujesz tylko kod tego konta.",
      loginOwn: "Inny dokument i hasło",
      aliasHint: "Służy tylko do rozpoznania go tutaj. Jeśli zostanie puste, konto jest pokazywane po kodzie placówki.",
      metaDoc: "Dokument",
      metaEst: "Placówka",
      leftWithout: "po zapisaniu bez konta. Ich check-iny przestaną być zgłaszane do SIRE.",
      errDocument: "Wpisz numer dokumentu.",
      errPassword: "Wpisz hasło do SIRE.",
      errPasswordNeeded: "Wpisz hasło nowego dokumentu.",
      savedValidated: "Konto zapisane i zweryfikowane przez SIRE.",
      savedNotValidated: "Zapisano, ale SIRE odrzuca dane. Sprawdź je.",
      savedUnchecked: "Konto zapisane. TRA nie pozwala sprawdzić tokenu z wyprzedzeniem: okaże się przy pierwszej wysyłce.",
    },

    tra: {
      name: "TRA",
      subtitle: "Registro de turistas alojados — Ministerio de Comercio, Industria y Turismo",
      intro: "Każda jednostka wysyła swój raport do TRA przez konto. Możesz używać jednego konta dla całej oferty albo przypisać inne wybranym jednostkom: każdy RNT oznacza jeden obiekt.",
      introSingle: "Połącz konto, przez które ta oferta wysyła swój raport do TRA.",
      emptyList: "Nie połączono jeszcze żadnego konta TRA.",
      withoutAccountText: "Ich pobyty nie są zgłaszane do TRA.",
      newTitle: "Nowe konto TRA",
      editTitle: "Edytuj konto TRA",
      modalSub: "To token i RNT tego obiektu",
      defaultName: "RNT {rnt}",
      tokenLabel: "Token",
      tokenPlaceholder: "Wklej tutaj swój token",
      tokenHint: "Generujesz go na",
      loginTitle: "Dostęp do TRA",
      loginSame: "Ten sam token",
      loginSameHint: "Wpisujesz tylko RNT tego konta.",
      loginOwn: "Inny token",
      rntLabel: "RNT",
      rntPlaceholder: "Np. 123456",
      rntHint: "Registro Nacional de Turismo tego obiektu. To właśnie on identyfikuje placówkę w TRA.",
      aliasHint: "Służy tylko do rozpoznania go tutaj. Jeśli zostanie puste, konto jest pokazywane po swoim RNT.",
      metaRnt: "RNT",
      metaToken: "Token",
      leftWithout: "po zapisaniu bez konta. Ich pobyty przestaną być zgłaszane do TRA.",
      errToken: "Wklej token do TRA.",
      errRnt: "RNT to liczba. Sprawdź go.",
      savedValidated: "Konto zapisane i zweryfikowane przez TRA.",
      savedNotValidated: "Zapisano, ale TRA odrzuca dane. Sprawdź je.",
      savedUnchecked: "Konto zapisane. TRA nie pozwala sprawdzić tokenu z wyprzedzeniem: okaże się przy pierwszej wysyłce.",
    },

    foreign: {
      ses: "SES Hospedajes (Hiszpania)",
      colombia: "SIRE i TRA (Kolumbia)",
      title: "Zostały konta {name}",
      text: "Ta oferta nie jest już w tym kraju, więc to konto nic nie zgłasza. | Ta oferta nie jest już w tym kraju, więc te {count} konta nic nie zgłaszają. | Ta oferta nie jest już w tym kraju, więc te {count} kont nic nie zgłasza.",
      remove: "Usuń je",
      removeTitle: "Usunąć zbędne konta?",
      removeMessage: "Zostanie usunięte konto {name}, które zostało z wcześniej. Nie wpływa to na urząd, z którego korzystasz teraz. | Zostaną usunięte {count} konta {name}, które zostały z wcześniej. Nie wpływa to na urząd, z którego korzystasz teraz. | Zostanie usuniętych {count} kont {name}, które zostały z wcześniej. Nie wpływa to na urząd, z którego korzystasz teraz.",
      removed: "Konta usunięte.",
      removeError: "Nie udało się ich usunąć.",
    },
  },

  // CheckoutMessage.vue
  checkoutMsg: {
    title: "Wiadomość check-out",
    subtitle: "Przypomnienie o check-oucie wysyłane wieczorem przed wyjazdem. Napisz własny tekst i skorzystaj z dostępnych zmiennych.",
    loading: "Wczytywanie…",
    enableTitle: "Wysyłaj wiadomość check-out",
    enableSub: "Zostanie wysłana automatycznie {day} o {time}.",
    dayLast: "w dniu wyjazdu",
    dayBefore: "dzień przed wyjazdem",
    cloneTitleNoun: "wiadomość check-out",
    cloneItemNoun: "wiadomość check-out",
    whenLabel: "Kiedy jest wysyłana",
    dayBeforeShort: "Dzień wcześniej",
    dayLastShort: "Dzień wyjazdu",
    atLabel: "O godzinie",
    timeHint: "W dniu wyjazdu godzina nie może być późniejsza niż check-out ({time}).",
    otaTitle: "Wysyłaj także przez OTA",
    textLabel: "Treść wiadomości check-out",
    translate: "Przetłumacz",
    translating: "Tłumaczenie…",
    attach: "Załącz",
    uploading: "Przesyłanie…",
    attachTitle: "Załączniki wiadomości check-out",
    emojis: "Emoji",
    searchEmoji: "Szukaj emoji…",
    variables: "Zmienne",
    varsHint: "Dotknij, aby je wstawić. Przy wysyłce zostaną zastąpione prawdziwymi danymi rezerwacji.",
    uploadDone: "Wysłano. Zapisywanie na serwerze…",
    attachLimits: "Zdjęcia i PDF do {file} MB · filmy MP4 do {video} MB.",
    attachLimitsWhy: "Takie są limity dopuszczane przez WhatsApp.",
    tipBefore: "Użyj",
    tipTextWord: "tekst",
    tipMid: "do zapisania czegoś",
    tipBoldWord: "pogrubioną czcionką",
    tipAfter: "(formatowanie WhatsApp). Gość otrzyma wiadomość w swoim języku, jeśli został on skonfigurowany.",
    attachShared: "Załączniki · wspólne dla wszystkich języków",
    delete: "Usuń",
    autosaveNote: "Zmiany są zapisywane automatycznie.",
    preview: "Podgląd",
    online: "online",
    previewHint: "Aktualizuje się wraz z Twoimi ustawieniami",
    dayOfCheckout: "Dzień wyjazdu",
    eveOfCheckout: "Wieczór przed wyjazdem",
    yourAccommodation: "Twoje zakwaterowanie",
    uploadSent: "{sent} z {total} MB",
    filesCount: "Pliki: {count}",
    placeholder: "np. Cześć {guest} 👋 Twój pobyt w obiekcie {property} kończy się jutro. Godzina check-outu to {time}. Dziękujemy za wizytę!",
    varGuestName: "Imię gościa",
    varPropertyName: "Nazwa zakwaterowania",
    varCheckoutTime: "Godzina check-outu",
    today: "dzisiaj",
    tomorrow: "jutro",
    previewDefault: "Cześć, *{guest}* 👋\n\nPrzypominamy, że Twój pobyt w obiekcie *{property}* kończy się {when}.\n\n🕚 Najpóźniejsza godzina check-outu to *{time}*.\n\nDziękujemy bardzo za pobyt. Szerokiej drogi! 😊",
    errVideoFormat: "❌ Plik {name} to film {ext}, a WhatsApp obsługuje tylko MP4. Przekonwertuj go na MP4 i prześlij ponownie.",
    errFileSize: "❌ Plik {name} ma {size} MB, a maksimum to {max} MB. ",
    errFileSizeVideo: "WhatsApp nie obsługuje większych filmów: skompresuj go lub skróć.",
    errFileSizeFile: "WhatsApp nie obsługuje większych plików.",
    attachUploaded: "Załączniki zostały przesłane",
    attachUploadError: "Błąd podczas przesyłania załączników",
    attachDeleted: "Załącznik został usunięty",
    attachDeleteError: "Nie udało się usunąć załącznika",
    loadError: "Nie udało się wczytać wiadomości check-out.",
    translateEmpty: "Napisz wiadomość w aktywnym języku przed tłumaczeniem.",
    translateSuccess: "Przetłumaczono języki: {count}! Sprawdź każdą zakładkę.",
    translatePartial: "Przetłumaczono: {ok}, nieudane: {fail}.",
    translateError: "Nie udało się przetłumaczyć. Spróbuj ponownie.",
    saved: "Wiadomość check-out została zapisana",
    saveError: "Nie udało się zapisać wiadomości check-out.",
  },
};
